import React from 'react';
import { /*BsInstagram,*/ BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Gallery.css';

const Gallery = () => {
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === 'left') {
      current.scrollLeft -= 300;
    } else {
      current.scrollLeft += 300;
    }
  }; 



  return (
    <div className="app__gallery flex__center">
      <div className="app__gallery-content">
        <SubHeading title="Our Team" />
        <h1 className="headtext__cormorant">Photo Gallery</h1>
        <p className="p__opensans" style={{ color: '#AAAAAA', marginTop: '2rem' }}>
       We are one-minded community that is committed to offer the keys that unlock the portal into the chambers of human flourishing. We focus on an array of vital topics and ideas.</p>
        <button type="button" className="custom__button">Tap Images</button>
      </div>
      <div className="app__gallery-images">
        <div className="app__gallery-images_container" ref={scrollRef}>
          {[images.gallery01].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             


             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
            
             <p class="image__title">
               Grold Otieno
             </p>
             <p class="image__description">
               Director 
             </p>
             
             <p class="image__description">
             Editor-in-Chief
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
         </div>

            </div>
          ))}

        


        

      {[images.gallery02].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
               Felix Modi
             </p>
             <p class="image__description">
              Head of Strategy and Innovation
             </p>
             <p class="image__description">
              Executive Editor
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
             
         </div>

            </div>
          ))}

      {[images.gallery03].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
           
             <p class="image__title">
               Fadhili Njagi 
             </p>
             <p class="image__description">
              Head of Engineering 
             </p>
             <p class="image__description">
             Software Eng. Advisor
             </p>
         </div> 

            </div>
          ))}

          {[images.gallery04].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
               Nelkon Owino
             </p>
             <p class="image__description">
              Chief Financial Officer
             </p>
             <p class="image__description">
             Executive Director of Events
             </p>
             <p class="image__description">
              Podcast and Media 
             </p>
         </div>
            
            </div>
          ))}

          {[images.gallery05].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
             Sharon Amondi 
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
             
         </div>

            </div>
          ))}

{[images.gallery06].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
              Boniface Sitian
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
            
             
         </div>

            </div>
          ))}


          {[images.gallery07].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
              Tracey Judy
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
            
             
         </div>

            </div>
          ))}

{[images.gallery08].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
              Pascal Owino
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
            
             
         </div>

            </div>
          ))}

{[images.gallery09].map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
             
             {/*<BsInstagram className="gallery__image-icon" />*/}
             <div class="image__overlay image__overlay--primary">
             
             <p class="image__title">
              Paula Atte
             </p>
             <p class="image__description">
              Contributing Writer
             </p>
            
             
         </div>

            </div>
          ))}

        </div>

        

       

       

        <div className="app__gallery-images_arrows">
          <BsArrowLeftShort className="gallery__arrow-icon" onClick={() => scroll('left')} />
          <BsArrowRightShort className="gallery__arrow-icon" onClick={() => scroll('right')} />
        </div>
      </div>
    </div>
  );
};

export default Gallery;